import Timeline from "./Timeline"
import Common from "./Common"

export default function () {
  return (
    <div className="ar-footer">
      <div className="ar-timeline">
        <Timeline />
      </div>
      <Common />
    </div>
  )
}
